import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewRef,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserProfile } from "../core/model/user-profile";
import { UserProfileService } from "../core/service/user-profile.service";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent implements OnInit, OnDestroy {
  profiles: UserProfile[];

  private destroy$ = new Subject<void>();

  constructor(
    private _userProfileService: UserProfileService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getUserProfiles();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getUserProfiles() {
    this._userProfileService
      .getUserProfiles()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.profiles = data;
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  private safeDetectChanges(): void {
    const view = this.cdr as ViewRef;
    if (view && !view.destroyed) {
      this.cdr.detectChanges();
    }
  }
}
